import schemaDefs from "./schemaDefs.json";

export const FORM_DEFINITION_SCHEMA_MODEL_URI =
  "https://rpaconnect.io/formDefinition/schema";
const formDefinitionSchemaJsonSchema = {
  uri: "https://app.rpaconnect.io//schema/schema.json",
  fileMatch: [FORM_DEFINITION_SCHEMA_MODEL_URI],
  schema: {
    $schema: "https://json-schema.org/draft-07/schema",
    $id: "https://app.rpaconnect.io/schemas/formDefinition/schema",
    $ref: "#/$defs/schema/IFormSchema",
    $defs: {
      schema: schemaDefs,
    },
  },
};
export default formDefinitionSchemaJsonSchema;
